import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import style from './style.vue';

@Component({
  components: {},
  mixins: [style],
})
export default class IconMenu extends Vue {
  @Prop({ default: () => {} })
    value: DisplayIconMenuData;

  @Prop({ default: 1 })
    themeCode: number;

  // 区块背景色
  get blockBackground() {
    return this.themeCode > 3 ? '#181818' : '#ffffff';
  }

  // 分割线颜色
  get borderColor() {
    return this.themeCode > 3 ? '#333333' : '#f2f2f2';
  }

  isSvg(val = ''): boolean {
    const arr = val.split('.') || [];
    return arr.pop() === 'svg';
  }

  render(h) {
    const displayValue = (this.value as DisplayIconMenuData).desc.list.filter(v => v.page !== 7);
    return (
      <div
        class={{
          'iconMenu': this.value.desc.type == 1,
          'iconMenu-list': this.value.desc.type == 2,
          // "box-shadow": true,
        }}
        style={`margin:0 ${this.value.desc.margin / 2}px;border-radius:${this.value.desc.borderRadius / 2}px;background: ${this.blockBackground};`}>
        {displayValue.map((iconItem, i) => {
          if (this.value.desc.type == 1) {
            return (
              <el-col span={6} class="icon-img-box" key={i}>
                <div class="icon-img margin-auto" style={`background-image:url(${iconItem.url}${this.isSvg(iconItem.url) ? '' : '?imageView2/1/w/150/h/150'})`}></div>
                <p class="icon-title-1">{iconItem.title}</p>
              </el-col>
            );
          } else {
            return (
              <div class="icon-img-box icon-list" style={`border-bottom: ${i != displayValue.length - 1 ? 1 : 0}px solid ${this.borderColor}`} key={i}>
                <div class="inline-block">
                  <img class="icon-img" src={`${iconItem.url}${this.isSvg(iconItem.url) ? '' : '?imageView2/1/w/150/h/150'}`}></img>
                </div>
                <div class="icon-title-2 inline-block">{iconItem.title}</div>
              </div>
            );
          }
        })}
      </div>
    );
  }
}
